<template>
  <div class="flex flex-col items-center justify-center">
    <img
      :src="img"
      :class="isSmall ? 'h-auto w-92' : 'h-auto w-202'"
      class="object-cover"
      :style="{ marginTop: `${top}px` }"
    >
    <span
      :style="{ marginBottom: `${bottom}px` }"
      class="mt-10 text-12 text-gray"
    >
      {{ word }}
    </span>
    <!-- 按钮 -->
    <div class="overflow-hidden rounded-16 w-full">
      <van-button
        v-if="isShowBtn"
        class="w-full"
        color="linear-gradient(270deg, #FC966E 0%, #F96654 100%)"
        @click="study"
      >
        {{ text }}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalEmpty',
  props: {
    word: {
      type: String,
      default: '',
    },
    top: {
      type: Number,
      default: 150,
    },
    bottom: {
      type: Number,
      default: 0,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    img: {
      type: String,
      default: '/img/fieldEmpty.png',
    },
    isShowBtn: {
      type: Boolean,
      default: false,
    },
    btnType: {
      type: String,
      default: '0',
    },
  },
  computed: {
    text () {
      if (!this.isShowBtn) { return '' }
      return this.btnType === '0' ? '立即登录' : '立即兑换'
    }
  },
  methods: {
    study () {
      if (!this.isShowBtn) { return }
      this.$push(
        this.$tkUa.isWechat ? this.btnType === '0'
          ? '/auth/login?type=login' : '/exchange/exchange' : this.btnType === '0'
          ? '/auth/scan' : '/exchange/exchange'
      )
    }

  }
}
</script>

<style scoped lang="scss">
</style>
